.FieldErrors {
  position: relative;
  display: grid;
  grid: auto / auto;
  overflow: hidden;
  height: fit-content;

  ul {
    position: relative;
    z-index: 0;
    overflow: hidden;
    margin-top: calc(-1 * var(--space-xs));
    width: 100%;
    font-size: 1rem;
    padding: var(--space-sm) var(--space-md);
    background-color: var(--accent-2);
    color: var(--white);
    border-radius: 0 0 var(--radius-sm) var(--radius-sm);
    animation: errorEnter 150ms ease-out;

    &.leaving {
      animation: errorExit 100ms ease-in forwards;
    }

    li {
      display: block;
      overflow-wrap: break-word;
    }
  }
}

@keyframes errorEnter {
  from {
    opacity: 0;
    margin-top: -50%;
  }

  to {
    opacity: 1;
    margin-top: calc(-1 * var(--space-xs));
  }
}

@keyframes errorExit {
  from {
    opacity: 1;
    margin-top: calc(-1 * var(--space-xs));
  }

  to {
    opacity: 0;
    margin-top: -50%;
  }
}
